import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class SpecialtyRecord extends RecordBase {
  static defaultAttributes = {
    name:                      '',
    is_active:                 true,
    appointment_duration:      0,
    appointment_interval:      0,
    external_id_ids:           '',
    created_at:                '',
    updated_at:                '',
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`specialties.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        name:        trAttr('name'),
        is_active:   trAttr('is_active'),
        appointment_duration: trAttr('appointment_duration'),
        appointment_interval: trAttr('appointment_interval'),
        external_id_ids: trAttr('external_id_ids'),
        created_at:  trAttr('created_at'),
        updated_at:  trAttr('updated_at'),
      };
    }
    return this._attributeNames;
  }

  toParams(attrs={}){
    const {
      name,
      is_active,
      appointment_duration,
      appointment_interval,
      external_id_ids,
      created_at,
      updated_at,
    } = this.toObject();
    return {
      data:{
        attributes:{
          name,
          is_active,
          appointment_duration,
          appointment_interval,
          external_id_ids,
          created_at,
          updated_at,
          ...attrs
        }
      }
    };
  }
}
